import { render, staticRenderFns } from "./TestSummary.vue?vue&type=template&id=3ed375d0&"
import script from "./TestSummary.vue?vue&type=script&lang=ts&"
export * from "./TestSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports